export { default } from './partners-section';
export { partnersSectionHandler } from './partners-section.handler';
export { partnersSectionContentfulQuery } from './partners-section.query';
